export default "__VITE_ASSET__Ehm3CWGX__"